/**
 * @deprecated Please use the `Grid` component.
 *
 * Load more functionality doesn't exist
 * in new `Grid`, so this may need to be
 * added if required
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CTAButton from '../ctaButton/CTAButton';

const DeprecatedGrid = ({ loadMore, children }) => {
  const [itemsShown, setItemsShown] = useState(parseInt(loadMore));

  const content = loadMore ? children.slice(0, itemsShown) : children;

  return (
    <>
      <div className="grid">{content}</div>
      {loadMore && children.length > itemsShown ? (
        <CTAButton type="Action" text="Load More" onClick={() => setItemsShown(itemsShown + 9)} />
      ) : null}
    </>
  );
};

DeprecatedGrid.propTypes = {
  children: PropTypes.node
};

export default DeprecatedGrid;
